/* configuration event enums */

export const CONFIG_CHAT_THROTTLED = 'ui/CONFIG_CHAT_THROTTLED';
export const CONFIG_UPDATE = 'configuration/UPDATE';
export const CONFIG_OFFICE_CLOSED = 'ui/CONFIG_OFFICE_CLOSED';
export const CONFIG_QUICK_ACTIONS_FETCH_SUCCESS = 'config/QUICK_ACTIONS_FETCH_SUCCESS';
export const CONFIG_REFRESH_SUCCESS = 'config/REFRESH_SUCCESS';
export const PROACTIVE_TRIGGERED = 'config/PROACTIVE_TRIGGERED';
export const SET_COHORT_ID = 'config/SET_COHORT_ID_MESSAGE';
export const SET_WELCOME_MESSAGE = 'config/SET_WELCOME_MESSAGE';

export const configurationEventTypes = {
  CONFIG_CHAT_THROTTLED,
  CONFIG_UPDATE,
  CONFIG_OFFICE_CLOSED,
  CONFIG_QUICK_ACTIONS_FETCH_SUCCESS,
  CONFIG_REFRESH_SUCCESS,
  PROACTIVE_TRIGGERED,
  SET_COHORT_ID,
  SET_WELCOME_MESSAGE,
};

/* configuration events */

export const updateConfig = config => ({ type: CONFIG_UPDATE, payload: config });
export const throttleChat = () => ({ type: CONFIG_CHAT_THROTTLED });
export const closeOffice = () => ({ type: CONFIG_OFFICE_CLOSED });
export const setWelcomeMessage = message => ({ type: SET_WELCOME_MESSAGE, payload: message });
export const setCohortId = cohortId => ({ type: SET_COHORT_ID, payload: cohortId });
export const fetchQuickActionsSuccess = quickActions => ({
  type: CONFIG_QUICK_ACTIONS_FETCH_SUCCESS,
  payload: { quickActions },
});

export default {
  updateConfig,
  throttleChat,
  closeOffice,
  setWelcomeMessage,
  setCohortId,
  fetchQuickActionsSuccess,
};
